import { apiConnection } from "@/services/api-connection";

class RouteManager {
  constructor() {}

  NEWS_ADMIN_ROUTES = ["adminNewsShow", "adminNewsList", "adminNewsLayout", "adminHome"];
  isNewsAdminRoute(route) {
    if (this.NEWS_ADMIN_ROUTES.includes(route)) {
      return true;
    }
  }

  getMagicLinkFromV2(cryptedId) {
    return apiConnection.get("/app/v2/redirect/short-link-reply/" + cryptedId).then((res) => res);
  }
}

export const routeManager = new RouteManager();
